import { useEffect, useState } from "react";
import api from "@/lib/api";

const cache = new Map();

function fetchAvatar(url) {
  if (cache.has(url)) return cache.get(url);
  const promise = api
    .get(url.replace(/^\/api/, ""), { responseType: "blob" })
    .then((r) => URL.createObjectURL(r.data))
    .catch(() => null);
  cache.set(url, promise);
  return promise;
}

export function invalidateAvatar(url) {
  if (url) cache.delete(url);
  else cache.clear();
}

export default function Avatar({ user, className = "h-8 w-8 text-xs", testid = "avatar" }) {
  const [src, setSrc] = useState(null);
  const url = user?.avatar_url || null;

  useEffect(() => {
    let on = true;
    if (!url) {
      setSrc(null);
      return;
    }
    fetchAvatar(url).then((s) => {
      if (on) setSrc(s);
    });
    return () => {
      on = false;
    };
  }, [url]);

  if (url && src) {
    return (
      <img
        src={src}
        alt={`${user?.name || "User"} profile picture`}
        data-testid={testid}
        className={`${className} shrink-0 rounded-full object-cover`}
      />
    );
  }
  return (
    <span
      data-testid={testid}
      className={`flex shrink-0 items-center justify-center rounded-full bg-[#111111] font-bold text-white ${className}`}
    >
      {(user?.name || "U").slice(0, 1).toUpperCase()}
    </span>
  );
}
